//@ts-nocheck
import React, {
  useState,
  useEffect,
  useCallback,
  useRef,
  useMemo,
} from "react";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { useAppDispatch } from "../../app/hooks";
import {
  fetchLocationListStatus,
  fetchQuestionJobData,
  fetchQuestionList,
  updateLocation,
} from "../../features/questionnaire/questionnaireSlice";
import Badge from "../common/Badge";
import DropDown from "../common/DropDown";
import { createTeamsPayload } from "../../features/questionnaire/questionnaireTypes";
import { ExclamationIcon, ThreeDotIcon } from "../icons";
import CreateJobQuestionnaire from "./CreateJobQuestionnaire";
import { UserDetails } from "../../features/auth/authTypes";
import { fetchJobPipelineDetailsData } from "../../features/pipeline/pipelineSlice";
import { fetchScoreCardPipelineDetailsData } from "../../features/scorecard/scoreCardSlice";

type ChannelProps = {
  userDetails: UserDetails | null;
};

function classNames(...classes: any) {
  return classes.filter(Boolean).join(" ");
}

const roleSearchList = [
  { name: "active" },
  { name: "deleted" },
  { name: "archived" },
];

// stages
const useClickOutside1 = (handler) => {
  const ref = useRef(null);

  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);

  return ref;
};

const UserStagesDropdown = ({
  assignUserList,
  onUserSelect,
  currentlyAssignedUser,
}) => {
  const [searchTerm1, setSearchTerm1] = useState("");
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);

  const dropdownRef = useClickOutside1(() => {
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  });

  // Memoized filtered users based on search term
  const filteredUsers = useMemo(() => {
    return assignUserList.filter((user) =>
      user.stage_name.toLowerCase().includes(searchTerm1.toLowerCase()),
    );
  }, [assignUserList, searchTerm1]);

  const handleUserSelect = (user) => {
    onUserSelect(user);
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  };

  const toggleDropdown = (e) => {
    // Prevent event from propagating to document
    e.stopPropagation();
    setIsDropdownOpen1(!isDropdownOpen1);
  };

  const buttonBgColor = currentlyAssignedUser
    ? "inline-flex capitalize items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
    : "inline-flex capitalize items-center h-[24px] rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-300";
  const buttonText = currentlyAssignedUser
    ? `Stage: ${currentlyAssignedUser}`
    : "Assign Stage";

  return (
    <div ref={dropdownRef} className="relative mt-1">
      <span
        className="table-tooltip before:!bottom-[-35px] before:!left-[72px]"
        data-title="Click to change stage"
      >
        <button onClick={toggleDropdown} className={`${buttonBgColor}`}>
          {buttonText}
        </button>
      </span>

      {isDropdownOpen1 && (
        <div className="absolute z-10 mt-[9px] left-[-16px] bg-white max-w-[191.05px] min-w-[191.05px] w-full overflow-hidden rounded-lg border border-border bg-popover py-1 px-0 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
          <div className="p-1 border-b">
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm1}
              onChange={(e) => setSearchTerm1(e.target.value)}
              className="w-full px-2 py-0 border rounded text-[12px] focus:outline-none focus:ring-0 focus:ring-blue-500 border-none outline-none"
            />
          </div>
          <ul className="max-h-60 overflow-y-auto p-1">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <li
                  key={user.id}
                  onClick={() => handleUserSelect(user)}
                  className="px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-[12px] leading-4 rounded-md"
                >
                  {user.stage_name}
                </li>
              ))
            ) : (
              <li className="px-3 py-0 text-gray-500 text-[12px]">
                No stages found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

// user

const useClickOutside1User = (handler) => {
  const ref = useRef(null);

  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);

  return ref;
};

const UserAssignedDropdown = ({
  assignUserList,
  onUserSelect,
  currentlyAssignedUser,
}) => {
  const [searchTerm1, setSearchTerm1] = useState("");
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);

  const dropdownRef = useClickOutside1User(() => {
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  });

  // Memoized filtered users based on search term
  const filteredUsers = useMemo(() => {
    return assignUserList.filter((user) =>
      user.name.toLowerCase().includes(searchTerm1.toLowerCase()),
    );
  }, [assignUserList, searchTerm1]);

  const handleUserSelect = (user) => {
    onUserSelect(user);
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  };

  const toggleDropdown = (e) => {
    // Prevent event from propagating to document
    e.stopPropagation();
    setIsDropdownOpen1(!isDropdownOpen1);
  };

  const buttonBgColor = currentlyAssignedUser
    ? "inline-flex capitalize items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
    : "inline-flex capitalize items-center h-[24px] rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-300";

  const buttonText = currentlyAssignedUser
    ? `User: ${currentlyAssignedUser}`
    : "Assign User";

  return (
    <div ref={dropdownRef} className="relative mt-1">
      <span
        className="table-tooltip before:!bottom-[-35px] before:!left-[72px]"
        data-title="Click to change user"
      >
        <button onClick={toggleDropdown} className={`${buttonBgColor}`}>
          {buttonText}
        </button>
      </span>

      {isDropdownOpen1 && (
        <div className="absolute z-10 mt-[9px] left-[-16px] bg-white max-w-[191.05px] min-w-[191.05px] w-full overflow-hidden rounded-lg border border-border bg-popover py-1 px-0 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
          <div className="p-1 border-b">
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm1}
              onChange={(e) => setSearchTerm1(e.target.value)}
              className="w-full px-2 py-0 border rounded text-[12px] focus:outline-none focus:ring-0 focus:ring-blue-500 border-none outline-none"
            />
          </div>
          <ul className="max-h-60 overflow-y-auto p-1">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <li
                  key={user.id}
                  onClick={() => handleUserSelect(user)}
                  className="px-3  py-1.5 hover:bg-gray-100 cursor-pointer text-[12px] leading-4 rounded-md"
                >
                  {user.name}
                </li>
              ))
            ) : (
              <li className="px-3 py-0 text-gray-500 text-[12px]">
                No user found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

// scorecard

const useClickOutsideScorecard = (handler) => {
  const ref = useRef(null);

  useEffect(() => {
    const listener = (event) => {
      // Do nothing if clicking ref's element or descendent elements
      if (!ref.current || ref.current.contains(event.target)) {
        return;
      }

      handler(event);
    };

    document.addEventListener("mousedown", listener);
    document.addEventListener("touchstart", listener);

    return () => {
      document.removeEventListener("mousedown", listener);
      document.removeEventListener("touchstart", listener);
    };
  }, [ref, handler]);

  return ref;
};

const UserAssignedScoreCardDropdown = ({
  assignUserList,
  onUserSelect,
  currentlyAssignedUser,
}) => {
  const [searchTerm1, setSearchTerm1] = useState("");
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);

  const dropdownRef = useClickOutsideScorecard(() => {
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  });

  // Memoized filtered users based on search term
  const filteredUsers = useMemo(() => {
    return assignUserList.filter((user) =>
      user.scorecard_name.toLowerCase().includes(searchTerm1.toLowerCase()),
    );
  }, [assignUserList, searchTerm1]);

  const handleUserSelect = (user) => {
    onUserSelect(user);
    setIsDropdownOpen1(false);
    setSearchTerm1("");
  };

  const toggleDropdown = (e) => {
    // Prevent event from propagating to document
    e.stopPropagation();
    setIsDropdownOpen1(!isDropdownOpen1);
  };

  const buttonBgColor = currentlyAssignedUser
    ? "inline-flex capitalize items-center rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10"
    : "inline-flex capitalize items-center h-[24px] rounded-md bg-gray-50 px-2 py-1 text-xs font-medium text-gray-600 border-dashed border border-gray-300";
  const buttonText = currentlyAssignedUser
    ? `Scorecard: ${currentlyAssignedUser}`
    : "Assign Scorecard";

  return (
    <div ref={dropdownRef} className="relative mt-1">
      <span
        className="table-tooltip before:!bottom-[-35px] before:!left-[72px]"
        data-title="Click to change scorecard"
      >
        <button onClick={toggleDropdown} className={`${buttonBgColor}`}>
          {buttonText}
        </button>
      </span>

      {isDropdownOpen1 && (
        <div className="absolute z-10 mt-[9px] left-[-16px] bg-white max-w-[191.05px] min-w-[191.05px] w-full overflow-hidden rounded-lg border border-border bg-popover py-1 px-0 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 ">
          <div className="p-1 border-b">
            <input
              type="text"
              placeholder="Search users..."
              value={searchTerm1}
              onChange={(e) => setSearchTerm1(e.target.value)}
              className="w-full px-2 py-0 border rounded text-[12px] focus:outline-none focus:ring-0 focus:ring-blue-500 border-none outline-none"
            />
          </div>
          <ul className="max-h-60 overflow-y-auto p-1">
            {filteredUsers.length > 0 ? (
              filteredUsers.map((user) => (
                <li
                  key={user.id}
                  onClick={() => handleUserSelect(user)}
                  className="px-3 py-1.5 hover:bg-gray-100 cursor-pointer text-[12px] leading-4 rounded-md"
                >
                  {user.scorecard_name}
                </li>
              ))
            ) : (
              <li className="px-3 py-0 text-gray-500 text-[12px]">
                No scorecard found
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

const JobQuestionnaireStagesDetails: React.FC<ChannelProps> = React.memo(
  ({ boardsFetched, setBoardsFetched }) => {
    const baseIdString =
      localStorage.getItem("UserBaseId") ||
      localStorage.getItem("createBaseId");
    const baseId = baseIdString ? JSON.parse(baseIdString) : null;
    const [searchVal, setSearchVal] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editBoardData, setEditBoardData] = useState<{
      id: number;
      baseId: number;
    } | null>(null);
    const dispatch = useAppDispatch();
    const [dataLoading, setDataLoading] = useState(false);
    const [selectSearchRole, setSelectSearchRole] = useState("active");
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const navigate = useNavigate();
    const { jobId } = useParams<{ jobId: string }>();
    const [pipelineStageData, setPipelineStageData] = useState([]);
    const [openUserListIds1, setOpenUserListIds1] = useState<number[]>([]);
    const [pipelineStageDataUser, setPipelineStageDataUser] = useState([]);
    const [openUserListIds1User, setOpenUserListIds1User] = useState<number[]>(
      [],
    );
    const [scorecardStageDataUser, setScorecardStageDataUser] = useState([]);
    const [openUserListIds1Scorecard, setOpenUserListIds1Scorecard] = useState<
      number[]
    >([]);

    // In Teams component
    useEffect(() => {
      // const teamInfoString = localStorage.getItem('baseQuestionnaireDataByJob');
      // if (teamInfoString) {
      //   const teamInfo = JSON.parse(teamInfoString);
      //   setBoardsFetched(teamInfo.data);
      //   setDataLoading(false);
      // } else {
      const fetchTeams = async () => {
        setDataLoading(true);
        try {
          const baseResponse = await dispatch(
            fetchQuestionJobData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "baseQuestionnaireDataByJob",
              JSON.stringify(baseResponse.payload),
            );
          } else {
            setBoardsFetched([]);
          }
        } catch (error) {
          console.error("Error fetching teams:", error);
          setBoardsFetched([]);
        } finally {
          setDataLoading(false);
        }
      };

      if (baseId) {
        fetchTeams();
      }
      // }
    }, [baseId, dispatch]);

    const handleDeleteBoard = useCallback(
      async (id: number, baseId: number) => {
        const payload: createTeamsPayload = {
          status: "deleted",
          id: id,
          job_id: jobId,
        };

        try {
          // Update existing team
          const response = await dispatch(
            updateLocation({
              payload,
              userId: baseId,
              id: id,
            }),
          );

          if (response?.payload) {
            toast.success(
              response?.payload?.message ||
                "Status has been updated successfully",
            );
            // Update the local storage and state
            // const updatedBoards = boardsFetched.map(board =>
            //   board.id === id ? { ...board, status: 'deleted' } : board
            // );

            const baseResponse = await dispatch(
              fetchQuestionJobData({
                baseId: Number(baseId),
                JobId: jobId,
              }),
            );

            if (baseResponse?.payload) {
              setBoardsFetched(baseResponse.payload.data);
              localStorage.setItem(
                "baseQuestionnaireDataByJob",
                JSON.stringify(baseResponse.payload),
              );
            }

            setIsModalOpen(false);
            setEditBoardData(null);
          } else {
            toast.error("Failed to update status");
          }
        } catch (error) {
          toast.error("An error occurred while updating the status");
          console.error(error);
        }
      },
      [boardsFetched, dispatch],
    );

    const handleArchivedBoard = useCallback(
      async (id: number, baseId: number) => {
        const payload: createTeamsPayload = {
          status: "archived",
          id: id,
          job_id: jobId,
        };

        try {
          // Update existing team
          const response = await dispatch(
            updateLocation({
              payload,
              userId: baseId,
              id: id,
            }),
          );

          if (response?.payload) {
            toast.success(
              response?.payload?.message ||
                "Status has been updated successfully",
            );
            // Update the local storage and state
            const updatedBoards = boardsFetched.map((board) =>
              board.id === id ? { ...board, status: "archived" } : board,
            );

            localStorage.setItem(
              "baseQuestionnaireDataByJob",
              JSON.stringify({ data: updatedBoards }),
            );

            setBoardsFetched(updatedBoards);

            setIsModalOpen(false);
            setEditBoardData(null);
          } else {
            toast.error("Failed to update status");
          }
        } catch (error) {
          toast.error("An error occurred while updating the status");
          console.error(error);
        }
      },
      [boardsFetched, dispatch],
    );

    // Add a new useEffect to handle updates from localStorage
    useEffect(() => {
      const handleStorageChange = (e: StorageEvent) => {
        if (e.key === "baseQuestionnaireDataByJob" && e.newValue) {
          const teamsDataArray = JSON.parse(e.newValue);
          setBoardsFetched(teamsDataArray.data || []);
        }
      };

      window.addEventListener("storage", handleStorageChange);
      return () => window.removeEventListener("storage", handleStorageChange);
    }, []);

    const handleEdit = useCallback(
      (id: number, baseId: number) => {
        const teamToEdit = boardsFetched.find((team) => team.id === id);
        if (teamToEdit) {
          setEditBoardData(teamToEdit);
          setIsModalOpen(true);
        }
      },
      [boardsFetched],
    );

    const openModal = () => {
      setEditBoardData(null); // Add this line
      setIsModalOpen(true);
    };

    const handleTeamsData = (id: any) => {
      navigate(`/${baseId}/job/${jobId}/manage/questionnaire/${id}`);
    };

    const handleSearchRoleChange = (role: string) => {
      setSelectSearchRole(role);
    };

    const handleActive = async () => {
      setLoading1(true);
      try {
        const res = await dispatch(
          fetchLocationListStatus({ baseId, status: "active" }),
        );
        if (res.payload) {
          setBoardsFetched(res.payload.data);
          localStorage.setItem(
            "baseQuestionnaireDataByJob",
            JSON.stringify(res.payload),
          );
        } else {
          console.error("No payload received");
        }
      } catch (error) {
        console.error("Delete failed:", error);
        alert("Failed to delete location data. Please try again later.");
      } finally {
        setLoading1(false);
      }
    };

    const handleDelete = async () => {
      setLoading1(true);
      try {
        const res = await dispatch(
          fetchLocationListStatus({ baseId, status: "deleted" }),
        );
        if (res.payload) {
          setBoardsFetched(res.payload.data);
          localStorage.setItem(
            "baseQuestionnaireDataByJob",
            JSON.stringify(res.payload),
          );
        } else {
          console.error("No payload received");
        }
      } catch (error) {
        console.error("Delete failed:", error);
        alert("Failed to delete location data. Please try again later.");
      } finally {
        setLoading1(false);
      }
    };

    const handleSuspend = async () => {
      setLoading(true);
      try {
        const res = await dispatch(
          fetchLocationListStatus({ baseId, status: "archived" }),
        );
        if (res.payload) {
          setBoardsFetched(res.payload.data);
          // Update local storage
          localStorage.setItem(
            "baseQuestionnaireDataByJob",
            JSON.stringify(res.payload),
          );
        } else {
          console.error("No payload received");
        }
      } catch (error) {
        console.error("Suspend failed:", error);
      } finally {
        setLoading(false);
      }
    };

    // useEffect(() => {
    //   const fetchData = async () => {
    //     if (jobId && baseId) {
    //       try {

    //         const res = await dispatch(fetchJobPipelineDetailsData({ baseId: Number(baseId), JobId: jobId })).unwrap()
    //         setPipelineStageData(res?.data.stages)
    //         //localstroage
    //         localStorage.setItem('jobPipelineStageData', JSON.stringify(res?.data));
    //         setPipelineStageData(res?.data.stages)
    //       } catch (error) {
    //         console.error("Error fetching document:", error);
    //       }
    //     }
    //   };

    //   fetchData();
    // }, [dispatch, jobId, baseId]);

    // Add this useEffect to populate assignUserList from localStorage
    useEffect(() => {
      const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
      if (userDetailsData) {
        const members = userDetailsData ? JSON.parse(userDetailsData) : [];

        // Transform members to the required format
        const userList = members.map((member: any) => ({
          id: member.id,
          name: member.name,
        }));
        // console.log('Available users in assignUserList:', userList);

        setPipelineStageDataUser(userList);
      }
    }, []);

    const handleAssignSelect1 = async (user, id) => {
      const boardToUpdate = boardsFetched.find((board) => board.id === id);

      const payload = {
        stage_id: user.id, // Assuming user.id is the correct field for the API
        // Include other necessary fields for the payload
      };

      if (boardToUpdate.assignedUser) {
        // Update existing location
        const response = await dispatch(
          updateLocation({
            payload,
            userId: baseId,
            id: boardToUpdate.id,
          }),
        );

        if (response.meta.requestStatus === "fulfilled") {
          setOpenUserListIds1((prev) => prev.filter((openId) => openId !== id));
          const baseResponse = await dispatch(
            fetchQuestionJobData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "baseQuestionnaireDataByJob",
              JSON.stringify(baseResponse.payload),
            );
            setOpenUserListIds1((prev) =>
              prev.filter((openId) => openId !== id),
            );
          }
          toast.success("Stages assigned successfully!");

          setBoardsFetched((prevBoards) =>
            prevBoards.map((board) =>
              board.id === id ? { ...board, assignedUser: user.name } : board,
            ),
          );
        } else {
          toast.error("Failed to assign stages.");
        }
      } else {
        // Create new location
        const response = await dispatch(
          updateLocation({ payload, userId: baseId, id: boardToUpdate.id }),
        );
        if (response.meta.requestStatus === "fulfilled") {
          setOpenUserListIds1((prev) => prev.filter((openId) => openId !== id));
          const baseResponse = await dispatch(
            fetchQuestionJobData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "baseQuestionnaireDataByJob",
              JSON.stringify(baseResponse.payload),
            );
            setOpenUserListIds1((prev) =>
              prev.filter((openId) => openId !== id),
            );
          }
          toast.success("Stages assigned successfully!");
          setBoardsFetched((prevBoards) =>
            prevBoards.map((board) =>
              board.id === id ? { ...board, assignedUser: user.name } : board,
            ),
          );
        } else {
          toast.error("Failed to assign stage.");
        }
      }

      setOpenUserListIds1((prev) => prev.filter((openId) => openId !== id));
    };

    const handleAssignSelect1USer = async (user, id) => {
      const boardToUpdate = boardsFetched.find((board) => board.id === id);

      const payload = {
        assign_to: user.id, // Assuming user.id is the correct field for the API
      };

      if (boardToUpdate.assignedUser) {
        // Update existing location
        const response = await dispatch(
          updateLocation({
            payload,
            userId: baseId,
            id: boardToUpdate.id,
          }),
        );

        if (response.meta.requestStatus === "fulfilled") {
          setOpenUserListIds1User((prev) =>
            prev.filter((openId) => openId !== id),
          );
          const baseResponse = await dispatch(
            fetchQuestionJobData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "baseQuestionnaireDataByJob",
              JSON.stringify(baseResponse.payload),
            );
            setOpenUserListIds1User((prev) =>
              prev.filter((openId) => openId !== id),
            );
          }
          toast.success("User assigned successfully!");

          setBoardsFetched((prevBoards) =>
            prevBoards.map((board) =>
              board.id === id ? { ...board, assignedUser: user.name } : board,
            ),
          );
        } else {
          toast.error("Failed to assign user.");
        }
      } else {
        // Create new location
        const response = await dispatch(
          updateLocation({ payload, userId: baseId, id: boardToUpdate.id }),
        );
        if (response.meta.requestStatus === "fulfilled") {
          setOpenUserListIds1User((prev) =>
            prev.filter((openId) => openId !== id),
          );
          const baseResponse = await dispatch(
            fetchQuestionJobData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "baseQuestionnaireDataByJob",
              JSON.stringify(baseResponse.payload),
            );
            setOpenUserListIds1((prev) =>
              prev.filter((openId) => openId !== id),
            );
          }
          toast.success("User assigned successfully!");
          setBoardsFetched((prevBoards) =>
            prevBoards.map((board) =>
              board.id === id ? { ...board, assignedUser: user.name } : board,
            ),
          );
        } else {
          toast.error("Failed to assign user.");
        }
      }

      setOpenUserListIds1User((prev) => prev.filter((openId) => openId !== id));
    };

    // scorecard

    useEffect(() => {
      if (baseId) {
        const fetchData1 = async () => {
          const storedBase = localStorage.getItem("baseScoreCardDataByJob");
          if (storedBase) {
            const teamInfo = JSON.parse(storedBase);
            setScorecardStageDataUser(teamInfo.data);
          } else {
            try {
              const baseResponse = await dispatch(
                fetchScoreCardPipelineDetailsData({
                  baseId: Number(baseId),
                  JobId: jobId,
                }),
              );
              setScorecardStageDataUser(baseResponse.payload.data);
            } catch (error) {
              console.error("Error fetching base member details:", error);
            }
          }
        };
        fetchData1();
      }
    }, [baseId, dispatch]);

    const handleAssignSelectScorecard = async (user, id) => {
      const boardToUpdate = boardsFetched.find((board) => board.id === id);

      const payload = {
        scorecard_id: user.id, // Assuming user.id is the correct field for the API
      };

      if (boardToUpdate.assignedUser) {
        // Update existing location
        const response = await dispatch(
          updateLocation({
            payload,
            userId: baseId,
            id: boardToUpdate.id,
          }),
        );

        if (response.meta.requestStatus === "fulfilled") {
          setOpenUserListIds1((prev) => prev.filter((openId) => openId !== id));
          const baseResponse = await dispatch(
            fetchQuestionJobData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "baseQuestionnaireDataByJob",
              JSON.stringify(baseResponse.payload),
            );
            setOpenUserListIds1((prev) =>
              prev.filter((openId) => openId !== id),
            );
          }
          toast.success("Scorecard assigned successfully!");

          setBoardsFetched((prevBoards) =>
            prevBoards.map((board) =>
              board.id === id ? { ...board, assignedUser: user.name } : board,
            ),
          );
        } else {
          toast.error("Failed to assign scorecard.");
        }
      } else {
        // Create new location
        const response = await dispatch(
          updateLocation({ payload, userId: baseId, id: boardToUpdate.id }),
        );
        if (response.meta.requestStatus === "fulfilled") {
          setOpenUserListIds1((prev) => prev.filter((openId) => openId !== id));
          const baseResponse = await dispatch(
            fetchQuestionJobData({
              baseId: Number(baseId),
              JobId: jobId,
            }),
          );

          if (baseResponse?.payload) {
            setBoardsFetched(baseResponse.payload.data);
            localStorage.setItem(
              "baseQuestionnaireDataByJob",
              JSON.stringify(baseResponse.payload),
            );
            setOpenUserListIds1((prev) =>
              prev.filter((openId) => openId !== id),
            );
          }
          toast.success("Scorecard assigned successfully!");
          setBoardsFetched((prevBoards) =>
            prevBoards.map((board) =>
              board.id === id ? { ...board, assignedUser: user.name } : board,
            ),
          );
        } else {
          toast.error("Failed to assign scorecard.");
        }
      }

      setOpenUserListIds1((prev) => prev.filter((openId) => openId !== id));
    };

    return (
      <>
        <Toaster richColors />

        <div className="h-full">
          <main className="py-[34px] lg:py-[70px] px-0 lg:px-10 h-full flex">
            <div className="px-[2px] sm:px-6 lg:px-8 w-full flex justify-center">
              <div className="w-full max-w-[640px]">
                <div className="flex flex-col gap-y-1 w-full">
                  <h2 className="text-[20px] lg:text-[24px] font-medium leading-8 text-[#1b1b1b] tracking-[-0.01rem]">
                    Job Questionnaires
                  </h2>
                  <p className="text-sm leading-5 text-[#5c5c5e] font-medium">
                    Create sets of questions to access candidates. Automatically
                    screen candidates and identify top talent faster.
                  </p>
                </div>

                <div className="bg-[#e0e0e0] w-full h-[1px] my-6"></div>
                <div className=" mt-6 lg:mt-10 flex items-center  w-full gap-x-3">
                  <div className="w-full lg:w-[40%]">
                    {/* <label htmlFor='searchEmail' className='wg-label inline-flex shrink-0 items-center gap-1 text-[14px] text-[#2f2f31] wg-antialiased leading-5'>
                    Questionnaire
                  </label> */}
                    <div className="mt-[0px]">
                      <input
                        type="text"
                        value={searchVal}
                        onChange={(e) => setSearchVal(e.target.value)}
                        name="search"
                        id="search"
                        placeholder="Search name.."
                        className="flex w-full grow border px-4 pt-2 pb-[10px] text-sm leading-6 shadow-[0 1px 2px 0 rgba(18, 18, 23, 0.05)] transition-colors duration-100 placeholder:text-surface-500 outline-indigo-600
                      focus:outline focus:outline-2 focus:-outline-offset-1 bg-background text-text-100 hover:border-[#a9a9bc] dark:hover:border-surface-200
                           border-[#e7e7e8] dark:border-surface-100 focus:outline-indigo-600 h-[34px] rounded-[0.375rem]"
                      />
                    </div>
                  </div>

                  <div className="w-full lg:w-[20%]">
                    <div className="mt-0">
                      <DropDown
                        onChangeValue={handleSearchRoleChange}
                        data={roleSearchList}
                        previousValue={selectSearchRole}
                        onDelete={handleDelete}
                        onArchived={handleSuspend}
                        onActive={handleActive}
                      />
                      {/* <DropDown onChangeValue={(value) => setSelectSearchRole(value)} data={roleSearchList} previousValue={selectSearchRole} /> */}
                    </div>
                  </div>
                  <div className="w-full lg:w-[40%]">
                    <div className="mt-[0px] flex justify-end">
                      <button
                        onClick={openModal}
                        type="button"
                        className=" inline-flex shrink-0  justify-center rounded-md bg-indigo-600 items-center px-[14px] py-1 text-[13px] font-medium h-[32px] leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline
                       focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                      >
                        Create Questionnaire
                      </button>
                    </div>
                  </div>
                </div>
                <div className="mt-6 pb-10 w-full">
                  <div className="bg-white rounded-lg border border-solid border-[#0009321f]">
                    <div className="font-semibold text-[#1c2024] text-sm  px-[11.4px] py-[11.4px] bg-[#00005506] border-b border-solid border-[#0009321f]">
                      Name
                    </div>
                    {dataLoading ? (
                      <div
                        className="flex items-center justify-center relative z-50"
                        style={{ height: "calc(100vh - 191px)" }}
                      >
                        <div className="simple-spinner-loader">
                          <span></span>
                        </div>
                      </div>
                    ) : boardsFetched?.length === 0 ? (
                      <div className="w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3">
                        <ExclamationIcon />
                        <p className="text-[#0000007a] text-[13px]">
                          No results found
                        </p>
                      </div>
                    ) : (
                      <>
                        {boardsFetched
                          ?.filter((post) => {
                            if (searchVal === "") {
                              return post;
                            } else if (
                              post?.questionset_name
                                ?.toLowerCase()
                                .includes(searchVal.toLowerCase()) ||
                              post?.questionset_description
                                ?.toLowerCase()
                                .includes(searchVal.toLowerCase())
                            ) {
                              return post;
                            }
                          })
                          .map((items: any, index: number) => {
                            let findStage =
                              items?.stage_id &&
                              pipelineStageData.find(
                                (user) => user.id === items.stage_id,
                              );

                            let findUser =
                              items?.assign_to &&
                              pipelineStageDataUser.find(
                                (user) => user.id === items.assign_to,
                              );

                            let findScoreCard =
                              items?.scorecard_id &&
                              scorecardStageDataUser.find(
                                (user) => user.id === items.scorecard_id,
                              );

                            return (
                              <div
                                key={index}
                                className="w-full flex border-b border-[#0009321f] last-of-type:border-none"
                              >
                                <ul className="list-none w-full">
                                  <li className="flex flex-row items-start justify-between text-[0.875rem] px-[11.4px] py-[11.4px] w-full">
                                    <div className="flex shrink-0 pr-0 mt-[4px]">
                                      <span
                                        className="flex h-[30px] w-[30px] shrink-0 items-center justify-center rounded-full border-none text-[14px] font-semibold text-white capitalize"
                                        style={{
                                          backgroundColor:
                                            items?.questionset_colour,
                                        }}
                                      >
                                        {items.questionset_name[0]}
                                      </span>
                                    </div>
                                    <div className="flex-1 px-4">
                                      <div
                                        className="flex justify-start items-center gap-x-2"
                                        onClick={() =>
                                          handleTeamsData(items?.id)
                                        }
                                      >
                                        <p className="text-[0.8125rem] font-semibold leading-5 text-[#1b1b1b] ">
                                          {items.questionset_name}
                                        </p>
                                        {items.ai_check === "yes" && (
                                          <span className="inline-flex capitalize items-center rounded-md bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                                            ai assist
                                          </span>
                                        )}
                                      </div>
                                      <p
                                        className="flex text-xs text-[12px] leading-4 text-[#5c5c5e] mt-[1px]"
                                        onClick={() =>
                                          handleTeamsData(items?.id)
                                        }
                                      >
                                        {items?.questionset_description}
                                      </p>

                                      <div className="flex items-center gap-x-1 flex-wrap">
                                        {/* <UserStagesDropdown
                                      assignUserList={pipelineStageData}
                                      onUserSelect={(user) => handleAssignSelect1(user, items.id)}
                                      currentlyAssignedUser={findStage?.stage_name}
                                    />

                                    <UserAssignedDropdown
                                      assignUserList={pipelineStageDataUser}
                                      onUserSelect={(user) => handleAssignSelect1USer(user, items.id)}
                                      currentlyAssignedUser={findUser?.name}
                                    /> */}

                                        <UserAssignedScoreCardDropdown
                                          assignUserList={
                                            scorecardStageDataUser
                                          }
                                          onUserSelect={(user) =>
                                            handleAssignSelectScorecard(
                                              user,
                                              items.id,
                                            )
                                          }
                                          currentlyAssignedUser={
                                            findScoreCard?.scorecard_name
                                          }
                                        />
                                      </div>
                                    </div>
                                    <div className="mt-[3px]">
                                      <Badge status={items?.status} />
                                    </div>
                                    <div className="pl-2 flex items-center">
                                      <Menu
                                        as="div"
                                        className="relative inline-block text-left"
                                      >
                                        <div>
                                          <MenuButton className="rounded-md flex items-center justify-center hover:bg-light-gray-200 focus:bg-light-gray-200 w-[32px] h-[32px]">
                                            <span className="sr-only">
                                              Open options
                                            </span>
                                            <ThreeDotIcon />
                                          </MenuButton>
                                        </div>

                                        <Transition
                                          enter="transition ease-out duration-100"
                                          enterFrom="transform opacity-0 scale-95"
                                          enterTo="transform opacity-100 scale-100"
                                          leave="transition ease-in duration-75"
                                          leaveFrom="transform opacity-100 scale-100"
                                          leaveTo="transform opacity-0 scale-95"
                                        >
                                          <MenuItems
                                            className="absolute z-10 mt-[9px] left-[0px] bg-white max-w-[108px] min-w-[108px] w-full overflow-hidden rounded-lg border border-border
                                 bg-popover p-1 text-popover-foreground shadow-lg shadow-black/5 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 
                                 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2
                                  data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2"
                                          >
                                            <div className="py-1">
                                              <MenuItem>
                                                {({ focus }) => (
                                                  <div
                                                    onClick={() =>
                                                      handleEdit(
                                                        items.id,
                                                        items.base_id,
                                                      )
                                                    }
                                                    className={classNames(
                                                      focus
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700",
                                                      "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                    )}
                                                  >
                                                    Edit
                                                  </div>
                                                )}
                                              </MenuItem>
                                              <MenuItem>
                                                {({ focus }) => (
                                                  <Link
                                                    to="#"
                                                    className={classNames(
                                                      focus
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700",
                                                      "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                    )}
                                                    onClick={() =>
                                                      handleDeleteBoard(
                                                        items.id,
                                                        items.base_id,
                                                      )
                                                    }
                                                  >
                                                    Delete
                                                  </Link>
                                                )}
                                              </MenuItem>
                                              <MenuItem>
                                                {({ focus }) => (
                                                  <Link
                                                    to="#"
                                                    onClick={() =>
                                                      handleArchivedBoard(
                                                        items.id,
                                                        items.base_id,
                                                      )
                                                    }
                                                    className={classNames(
                                                      focus
                                                        ? "bg-gray-100 text-gray-900"
                                                        : "text-gray-700",
                                                      "relative flex cursor-default select-none items-center gap-2 rounded-md px-2 py-1.5 text-sm outline-none transition-colors focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0",
                                                    )}
                                                  >
                                                    Archived
                                                  </Link>
                                                )}
                                              </MenuItem>
                                            </div>
                                          </MenuItems>
                                        </Transition>
                                      </Menu>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            );
                          })}
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>

        <CreateJobQuestionnaire
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          editBoardData={editBoardData}
          baseId={baseId}
          setEditBoardData={setEditBoardData}
        />
      </>
    );
  },
);
export default JobQuestionnaireStagesDetails;
